module.exports = __webpack_public_path__ + "static/media/STElogo.5a45169f.jpg";